import { action, decorate, observable } from "mobx";
import { toast } from "react-toastify";

class ConfirmationDialogStore {
  constructor() {
    this.isOpen = false;
    this.children = null;
    this.action = null;
    this.executing = false;
    this.title = "";
  }

  close() {
    this.isOpen = false;
  }

  open(title, children, callback, successText, failureText) {
    this.title = title;
    this.children = children;
    this.callback = callback;
    this.successText = successText;
    this.failureText = failureText;
    this.isOpen = true;
  }

  execute() {
    this.executing = true;
    try {
      this.callback().then(() => {
        toast.success(this.successText, {
          position: "top-right",
          autoClose: 3000
        });
      });
    } catch (e) {
      toast.error(this.failureText, {
        position: "top-right",
        autoClose: 3000
      });
    } finally {
      this.executing = false;
      this.close();
    }
  }
}

decorate(ConfirmationDialogStore, {
  isOpen: observable,
  executing: observable,
  execute: action
});

export default ConfirmationDialogStore;



// WEBPACK FOOTER //
// ./src/stores/ConfirmationDialogStore.js